var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"register-play-date"},[_c('h1',[_vm._v("Schedule a Play Date")]),_c('schedule-play-date-form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }